import type { GatewayClient } from '@clawlet/gateway-client';

/**
 * Module-level reference to the active GatewayClient instance.
 * Set by useGateway on connect, cleared on disconnect.
 * Used by fileEditorStore to make API calls without prop drilling.
 */
export const gatewayRef: { current: GatewayClient | null } = { current: null };
